import type { Dispatch } from 'react';
import { RequestError } from '@ynomia/client';
import { SET_FETCHING_LAYERS, SET_LAST_FETCH_START_TIME, SET_LAYERS } from './actionTypes';
import { LayerAction } from '../context';
import { fetchLayers } from '../services';
import { notification } from '../antdProvider';

const setLayersLoading = (
  status: boolean,
  dispatch: Dispatch<LayerAction>,
) => dispatch({ type: SET_FETCHING_LAYERS, payload: status });

export const getLayers = async (
  tenant: string,
  projectCode: string,
  modifiedAfter: Date | null,
  dispatch: Dispatch<LayerAction>,
) => {
  const lastFetchStartTime = new Date();
  setLayersLoading(true, dispatch);
  try {
    const res = await fetchLayers(tenant, projectCode, modifiedAfter);
    dispatch({
      type: SET_LAYERS,
      payload: new Map(res.map(layer => [layer.id, layer])),
    });
    dispatch({
      type: SET_LAST_FETCH_START_TIME,
      payload: lastFetchStartTime,
    });
  } catch (error) {
    const { status, body } = error as RequestError;

    if (status || body) {
      notification.error({
        key: 'fetchLayersError',
        message: status,
        description: body?.msg || '',
      });
    }
  }
  setLayersLoading(false, dispatch);
};
